interface StatConfig {
  value: string
  numericValue: number
  suffix: string
  label: string
  bg: string
}

export const brackyArenaConfig = {
  stats: [
    { value: "74.5K+", numericValue: 74483, suffix: "+", label: "Global Fan Network", bg: "" },
    { value: "265.3K+", numericValue: 265536, suffix: "+", label: "@BRACKY MESSAGES", bg: "" },
    { value: "155.3K+", numericValue: 155300, suffix: "+", label: "LIVE BRACKET BETS ", bg: "" },
  ] as StatConfig[],
  animation: {
    intersectionThreshold: 0.3,
    animationDuration: 1500,
  },
  classes: {
    section:
      "relative z-20 w-full max-w-[90%] sm:max-w-md lg:max-w-[85%] xl:max-w-6xl mx-auto lg:px-6 py-2 sm:py-3 mt-2",
    scoreboard: "relative mx-auto bg-white/5 rounded-3xl border backdrop-blur-xl border-white/5 py-6 md:py-8 w-full",
    statContainer:
      "relative flex-1 py-5 md:py-6 flex flex-col items-center justify-center lg:after:content-[''] lg:after:absolute lg:after:left-0 lg:after:top-[4%] lg:after:h-[92%] lg:after:w-px lg:after:bg-white/[0.07] lg:first:after:hidden before:content-[''] before:absolute before:left-1/2 before:-translate-x-1/2 before:w-[80%] before:bottom-0 before:h-px before:bg-white/[0.07] before:block lg:before:hidden last:before:hidden",
    statLabel: "text-white/70 text-[.875rem] sm:text-[1.04rem] font-normal uppercase tracking-wider mb-[0.45rem]",
    statValue:
      "relative inline-flex items-center justify-center px-3 py-1 before:absolute before:inset-0 before:-z-10 before:rounded-xl before:bg-black/20 before:border before:border-white/10 after:absolute after:inset-0 after:pointer-events-none bg-linear-to-b from-white to-[#dce3fe] bg-clip-text text-transparent font-extrabold leading-none text-[1.7rem] sm:text-[1.9rem] md:text-[2.2rem] lg:text-[2.5rem]",
    cta: {
      wrapper: "mt-10 mb-4 md:mb-6 flex flex-col items-center justify-center",
      subtitle: "hidden sm:block -mt-[2.8rem] text-xs sm:text-sm text-white/50 text-center",
    },
  },
  gradients: {
    topFade:
      "linear-gradient(to bottom, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.15) 25%, rgba(0,0,0,0.0375) 40%, transparent 50%)",
  },
}
